"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "emptyUser", {
    enumerable: !0,
    get: function() {
        return emptyUser;
    }
});
const _CommonProto = require("../../api/generated/CommonProto");
function emptyUser() {
    return {
        autoBilling: !1,
        id: '',
        kycStatus: _CommonProto.KycStatus.UNKNOWN
    };
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9odHRwL21vZGVscy9Vc2VyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEt5Y1N0YXR1cyB9IGZyb20gJy4uLy4uL2FwaS9nZW5lcmF0ZWQvQ29tbW9uUHJvdG8nXG5pbXBvcnQgdHlwZSB7IFVzZXIgfSBmcm9tICcuLi8uLi9hcGkvZ2VuZXJhdGVkL1VzZXJQcm90bydcblxuZXhwb3J0IGZ1bmN0aW9uIGVtcHR5VXNlcigpOiBVc2VyIHtcbiAgICByZXR1cm4ge1xuICAgICAgICBhdXRvQmlsbGluZzogZmFsc2UsXG4gICAgICAgIGlkOiAnJyxcbiAgICAgICAga3ljU3RhdHVzOiBLeWNTdGF0dXMuVU5LTk9XTixcbiAgICB9XG59XG4iXSwibmFtZXMiOlsiZW1wdHlVc2VyIiwiYXV0b0JpbGxpbmciLCJpZCIsImt5Y1N0YXR1cyIsIkt5Y1N0YXR1cyIsIlVOS05PV04iXSwibWFwcGluZ3MiOiI7OzttQ0FHZ0JBOzs7ZUFBQUE7Ozs2QkFIVTtBQUduQixTQUFTQTtJQUNaLE9BQU87UUFDSEMsYUFBYSxDQUFBO1FBQ2JDLElBQUk7UUFDSkMsV0FBV0Msc0JBQVMsQ0FBQ0MsT0FBTztJQUNoQztBQUNKIn0=